import axios from 'axios';
import { REQUEST_URL, URL_PAGAMENTO } from '../config/urls';
import { toast } from 'react-toastify';
import EmailServices from '../services/email';

const requisitar = () => {
  return {
    type: 'REQUISITAR_CONTRATO',
  };
};
const obterTodos = (contratos) => {
  return {
    type: 'OBTER_TODOS_CONTRATOS',
    contratos,
  };
};
const obterTodosAguardando = (contratos) => {
  return {
    type: 'OBTER_TODOS_C_AGUARDANDO',
    contratos,
  };
};
const obterTodosInserir = (contratos) => {
  return {
    type: 'OBTER_CONTRATOS_INSERIR',
    contratos,
  };
};
const obterTodosCadastrados = (contratos) => {
  return {
    type: 'OBTER_TODOS_C_CADASTRADO',
    contratos,
  };
};
const obterTodosArquivados = (contratos) => {
  return {
    type: 'OBTER_TODOS_C_ARQUIVADOS',
    contratos,
  };
};
const obterTodosConfigurado = (contratos) => {
  return {
    type: 'OBTER_TODOS_C_CONFIGURADO',
    contratos,
  };
};
const obterTodosConfigurar = (contratos) => {
  return {
    type: 'OBTER_TODOS_C_CONFIGURAR',
    contratos,
  };
};
const obterTodosProcessando = (contratos) => {
  return {
    type: 'OBTER_TODOS_C_PROCESSANDO',
    contratos,
  };
};
const obterTodosFinalizados = (contratos) => {
  return {
    type: 'OBTER_TODOS_C_FINALIZADOS',
    contratos,
  };
};
const obterTodosPagamentoIndividual = (contratos) => {
  return {
    type: 'OBTER_TODOS_C_PAGAMENTO_INDIVIDUAL',
    contratos,
  };
};
const obterVencidos = (contratos) => {
  return {
    type: 'OBTER_VENCIDOS',
    contratos,
  };
};
const obterQuaseVencidos = (contratos) => {
  return {
    type: 'OBTER_QUASE_VENCIDOS',
    contratos,
  };
};
const obterEspecifico = (contrato) => {
  return {
    type: 'OBTER_ESPECIFICO',
    contrato,
  };
};
const novoContrato = (contrato) => {
  return {
    type: 'NOVO_CONTRATO',
    contrato,
  };
};
const alterarContrato = (contrato) => {
  return {
    type: 'ALTERAR_CONTRATO',
    contrato,
  };
};
const transfereContrato = (contrato) => {
  return {
    type: 'TRANSFERIR_CONTRATO',
    contrato,
  };
};
const removerContrato = (id) => {
  return {
    type: 'REMOVER_CONTRATO',
    id,
  };
};
const planilhaLiberada = (status, contratoId) => {
  return {
    type: 'LIBERACAO_PLANILHA_QUANTIDADES',
    status,
    contratoId,
  };
};
const planilhaEstornada = (extornada, contratoId) => {
  return {
    type: 'ESTORNO_PLANILHA_QUANTIDADES',
    extornada,
    contratoId,
  };
};
const statusDistBrindes = (status, contratoId) => {
  return {
    type: 'STATUS_DIST_BRINDES',
    status,
    contratoId,
  };
};
const statusEndEntrega = (status, contratoId) => {
  return {
    type: 'STATUS_END_ENTREGA',
    status,
    contratoId,
  };
};
const statusPersonalizacaoLiberada = (status, contratoId) => {
  return {
    type: 'STATUS_PERSONALIZACAO_LIBERADA',
    status,
    contratoId,
  };
};
const erro = (erro) => {
  if (
    erro.response !== undefined &&
    erro.response.data.error.statusCode === 401
  ) {
    axios.defaults.headers.common['Authorization'] = '';
    return {
      type: 'LOGOUT',
    };
  }
  return {
    type: 'ERRO_CONTRATO',
    erro,
  };
};
/*
const transfContrato = (contrato) => {
  return {
    type: "TRANSFERIR_CONTRATO",
    contrato
  }
}
*/

export const adicionarContrato = (contrato) => {
  return (dispatch) => {
    dispatch(requisitar());
    return axios
      .post(`${REQUEST_URL}/contratos`, contrato)
      .then((response) => {
        // Os contatos agora são armazenados no mapa
        if (contrato.idClienteMapa === null) {
          contrato.contatos.forEach((item) => {
            item.contrato = response.data.id;
            axios.post(`${REQUEST_URL}/usuariosContratos`, item);
          });
          contrato.itens.forEach((item) => {
            item.contrato = response.data.id;
            axios.post(`${REQUEST_URL}/itens`, item);
          });
        }
        //cadastro da notificacao
        let acao = {
          ator: contrato.dono,
          texto:
            'Contrato número ' + contrato.numero + ' cadastrado no sistema.',
          contrato: response.data.id,
          data: new Date(),
          tipo: 'notificacao',
          visualizado: false,
        };
        axios.post(`${REQUEST_URL}/acoes`, acao).catch((error) => {
          dispatch(erro(error.response));
        });
        dispatch(novoContrato(response.data));
      })
      .catch((error) => {
        dispatch(erro(error));
      });
  };
};

export const adicionarContratoAntigo = (contrato) => {
  return (dispatch) => {
    dispatch(requisitar());
    return axios
      .post(`${REQUEST_URL}/contratos`, contrato)
      .then((response) => {
        let email = new EmailServices();
        email.enviar('comissao', {
          login: {
            email: response.data.usuarioComissao.login,
            senha: response.data.usuarioComissao.senha,
          },
          usuario: {
            nome: response.data.usuarioComissao.login,
            email: response.data.usuarioComissao.login,
          },
        });
        email.enviar('comissaoDesigner', {
          numero: contrato.numero,
          usuario: {
            email: response.data.usuarioComissao.login,
            senha: response.data.usuarioComissao.senha,
            nome: response.data.usuarioComissao.login,
          },
          designer: { email: contrato.emailDesigner },
        });
        //cadastro da notificacao
        let acao = {
          ator: contrato.dono,
          texto:
            'Contrato número ' + contrato.numero + ' cadastrado no sistema.',
          contrato: response.data.id,
          data: new Date(),
          tipo: 'notificacao',
          visualizado: false,
        };
        axios.post(`${REQUEST_URL}/acoes`, acao).catch((error) => {
          dispatch(erro(error.response.data.error));
        });
        toast.success('Contrato cadastrado com sucesso!');
        dispatch(novoContrato(response.data));
      })
      .catch((error) => {
        console.log(error);
        dispatch(erro(error));
      });
  };
};

export const editarContrato = (id, contrato) => {
  return (dispatch) => {
    dispatch(requisitar());
    return axios
      .patch(`${REQUEST_URL}/contratos/${id}`, contrato)
      .then((response) => {
        if (
          contrato.idClienteMapa === null &&
          contrato.status === 'cadastrar'
        ) {
          contrato.contatos.forEach((item) => {
            item.contrato = response.data.id;
            axios.post(`${REQUEST_URL}/usuariosContratos`, item);
          });
          contrato.itens.forEach((item) => {
            item.contrato = id;
            axios.post(`${REQUEST_URL}/itens`, item);
          });
        }
        dispatch(alterarContrato(response.data));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const editarCamposContrato = (id, contrato, status) => {
  return (dispatch) => {
    dispatch(requisitar());
    return axios
      .patch(`${REQUEST_URL}/contratos/${id}`, contrato)
      .then((response) => {
        dispatch(alterarContrato(response.data));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const countContratosNovos = (donoId) => {
  return (dispatch) => {
    let where = '';
    if (donoId) {
      where = `, "dono": ${donoId}`;
    }
    return axios
      .get(
        `${REQUEST_URL}/contratos/count?where={"status":"aguardando"` +
          where +
          `}`
      )
      .then((response) => {
        dispatch({ type: 'COUNT_CONTRATOS_NOVOS', qtd: response.data.count });
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const countContratosConfigurados = (donoId) => {
  return (dispatch) => {
    let where = '';
    if (donoId) {
      where = `, "dono": ${donoId}`;
    }
    return axios
      .get(
        `${REQUEST_URL}/contratos/count?where={"status":"configurado"` +
          where +
          `}`
      )
      .then((response) => {
        dispatch({
          type: 'COUNT_CONTRATOS_CONFIGURADO',
          qtd: response.data.count,
        });
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const countContratosProcessando = (donoId) => {
  return (dispatch) => {
    let where = '';
    if (donoId) {
      where = `, "dono": ${donoId}`;
    }
    return axios
      .get(
        `${REQUEST_URL}/contratos/count?where={"status":"processando"` +
          where +
          `}`
      )
      .then((response) => {
        dispatch({
          type: 'COUNT_CONTRATOS_PROCESSANDO',
          qtd: response.data.count,
        });
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const countContratosFinalizado = (donoId) => {
  return (dispatch) => {
    let where = '';
    if (donoId) {
      where = `, "dono": ${donoId}`;
    }
    return axios
      .get(
        `${REQUEST_URL}/contratos/count?where={"status":"finalizado"` +
          where +
          `}`
      )
      .then((response) => {
        dispatch({
          type: 'COUNT_CONTRATOS_FINALIZADOS',
          qtd: response.data.count,
        });
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const transferirContrato = (contrato, id) => {
  return (dispatch) => {
    dispatch(requisitar());
    return axios
      .post(`${REQUEST_URL}/contratos/update?where[id]=${id}`, contrato)
      .then((response) => {
        dispatch(transfereContrato(response.data));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const deletarContrato = (id) => {
  return (dispatch) => {
    dispatch(requisitar());
    return axios
      .get(
        `${REQUEST_URL}/contratos/${id}?filter[include]=formandos&filter[include]=itens`
      )
      .then((response) => {
        for (let i = 0; i < response.data.formandos.length; i++) {
          let formando = response.data.formandos[i];
          axios
            .delete(`${REQUEST_URL}/formandos/${formando.id}`)
            .catch((error) => dispatch(erro(error.response.data.error)));
        }
        for (let i = 0; i < response.data.itens.length; i++) {
          let item = response.data.itens[i];
          axios
            .delete(`${REQUEST_URL}/itens/${item.id}`)
            .catch((error) => dispatch(erro(error.response.data.error)));
        }
        axios
          .delete(`${REQUEST_URL}/contratos/${id}`)
          .then((response) => {
            dispatch(removerContrato(id));
          })
          .catch((error) => {
            dispatch(erro(error.response.data.error));
          });
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const obterContratos = () => {
  return (dispatch) => {
    dispatch(requisitar());
    return axios
      .get(
        `${REQUEST_URL}/contratos?filter={"include":["itens","formandos","usuario","dono", "turmas"]}]}`
      )
      .then((response) => {
        dispatch(obterTodos(response.data));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const obterContratosSemInclude = () => {
  return (dispatch) => {
    dispatch(requisitar());
    return axios
      .get(
        `${REQUEST_URL}/contratos?filter={
      "where": {
        "and": [
          {"status": {"neq": "deletado"}}, 
          {"status": {"neq": "arquivado"}},
          {"status": {"neq": "finalizado"}}
        ]
      } 
    }`
      )
      .then((response) => {
        dispatch(obterTodos(response.data));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const obterContratosTabelaTodos = () => {
  return (dispatch) => {
    dispatch(requisitar());
    // {"numOrcamento": {"neq": ""}}
    return axios
      .get(
        `${REQUEST_URL}/contratos?filter={
        "where": {
          "and": [
            {"status": {"neq": "deletado"}}, 
            {"status": {"neq": "arquivado"}},
            {"status": {"neq": "finalizado"}}
          ]
        }, 
        "include":["itens","formandos","usuario","dono", "turmas"]
      }`
      )
      .then((response) => {
        dispatch(obterTodos(response.data));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const obterContratosPeloOrcamento = (orcamento) => {
  return (dispatch) => {
    dispatch(requisitar());
    return axios
      .get(
        `${REQUEST_URL}/contratos?filter={"include":["itens", "formandos", "usuario", "dono", "turmas"], "where": {"numOrcamento": ${orcamento}}}`
      )
      .then((response) => {
        dispatch(obterTodos(response.data));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const obterContratosPeloDono = (donoId) => {
  return (dispatch) => {
    dispatch(requisitar());
    return axios
      .get(
        `${REQUEST_URL}/contratos?filter={"include":["itens", "formandos", "usuario", "dono", "turmas"], "where": {"dono": ${donoId}}}`
      )
      .then((response) => {
        dispatch(obterTodos(response.data));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const obterPrazoVencido = (donoId) => {
  return (dispatch) => {
    dispatch(requisitar());
    let where = '';
    if (donoId) {
      where = `, "dono": ${donoId}`;
    }
    let request = `${REQUEST_URL}/contratos?
                    filter={
                      "where":{"and":[
                        {"prazoFinalizacao":{"lte":"${new Date().toISOString()}"}},
                        {"status":{"neq":"finalizado"}},
                        {"status":{"neq":"arquivado"}},
                        {"status":{"neq":"deletado"}}]
                        where
                      },
                      "limit":"10"
                    }`;
    return axios
      .get(request)
      .then((response) => {
        dispatch(obterVencidos(response.data));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const obterPrazoQuaseVencido = (donoId) => {
  return (dispatch) => {
    dispatch(requisitar());
    let where = '';
    if (donoId) {
      where = `, "dono": ${donoId}`;
    }
    let data = new Date();
    data.setDate(data.getDate() + 7);
    let request =
      `${REQUEST_URL}/contratos?` +
      `filter={` +
      `"where":{"and":[` +
      `{"prazoFinalizacao":{"lte":"${data.toISOString()}"}},` +
      `{"prazoFinalizacao":{"gt": "${new Date().toISOString()}"}},` +
      `{"status":{"neq":"finalizado"}},
                         {"status":{"neq":"arquivado"}},
                         {"status":{"neq":"deletado"}}
                      ]` +
      where +
      `},` +
      `"limit":"10"` +
      `}`;
    return axios
      .get(request)
      .then((response) => {
        dispatch(obterQuaseVencidos(response.data));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const obterContrato = (id) => {
  return (dispatch) => {
    dispatch(requisitar());
    return axios
      .get(
        `${REQUEST_URL}/contratos/${id}?filter={"include":["itens","formandos","usuario","dono", "turmas"]}`
      )
      .then((response) => {
        dispatch(obterEspecifico(response.data));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const obterContratoPeloNumero = (numero) => {
  return (dispatch) => {
    dispatch(requisitar());
    return axios
      .get(
        `${REQUEST_URL}/contratos?filter={"where":{"numero":"${numero}"}, "include": [{"publicacoes": [{"paginas": ["comentarios"]}, "pesquisas"]}, "dono", "usuario", "itens", "turmas"]}`
      )
      .then((response) => {
        dispatch(obterEspecifico(response.data[0]));
      })
      .catch((error) => {
        dispatch(erro(error));
      });
  };
};

export const obterContratosNovos = (donoId) => {
  return (dispatch) => {
    dispatch(requisitar());
    let where = '';
    if (donoId) {
      where = `, "dono": ${donoId}`;
    }
    return axios
      .get(
        `${REQUEST_URL}/contratos?filter={"where":{"status":"aguardando"` +
          where +
          `},"include":["usuario", "turmas"]}`
      )
      .then((response) => {
        dispatch(obterTodosAguardando(response.data));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const obterContratosCadastrados = (donoId) => {
  return (dispatch) => {
    dispatch(requisitar());
    let where = '';
    if (donoId !== -1) {
      where = `, "dono": ${donoId}`;
    }
    return axios
      .get(
        `${REQUEST_URL}/contratos?filter={"where":{"status":"cadastrar"` +
          where +
          `},"include":["usuario", "turmas"]}`
      )
      .then((response) => {
        dispatch(obterTodosCadastrados(response.data));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const obterContratosInserir = () => {
  return (dispatch) => {
    dispatch(requisitar());
    return axios
      .get(
        `${REQUEST_URL}/contratos?filter={"where":{"status":"inserir"},"include":["usuario", "itens", "turmas"]}`
      )
      .then((response) => {
        dispatch(obterTodosInserir(response.data));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const obterContratosArquivados = (donoId) => {
  return (dispatch) => {
    dispatch(requisitar());
    let where = '';
    if (donoId) {
      where = `, "dono": ${donoId}`;
    }
    return axios
      .get(
        `${REQUEST_URL}/contratos?filter={"where":{"status":"arquivado"` +
          where +
          `},"include":["usuario", "turmas"]}`
      )
      .then((response) => {
        dispatch(obterTodosArquivados(response.data));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const obterContratosProcessando = (donoId) => {
  return (dispatch) => {
    dispatch(requisitar());
    let where = '';
    if (donoId) {
      where = `, "dono": ${donoId}`;
    }
    return axios
      .get(
        `${REQUEST_URL}/contratos?filter={"where":{"status":"processando"` +
          where +
          `},"include":["itens","formandos","usuario","dono", "endereco", "turmas"]}`
      )
      .then((response) => {
        dispatch(obterTodosProcessando(response.data));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const obterContratosConfigurados = (donoId) => {
  return (dispatch) => {
    dispatch(requisitar());
    let where = '';
    if (donoId) {
      where = `, "dono": ${donoId}`;
    }
    return axios
      .get(
        `${REQUEST_URL}/contratos?filter={"where":{"status":"configurado"` +
          where +
          `},"include":["itens","usuario","turmas"]}`
      )
      .then((response) => {
        dispatch(obterTodosConfigurado(response.data));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const obterContratosConfigurar = (donoId) => {
  return (dispatch) => {
    dispatch(requisitar());
    let where = '';
    if (donoId) {
      where = `, "dono": ${donoId}`;
    }
    return axios
      .get(
        `${REQUEST_URL}/contratos?filter={"where":{"status":"configurar"` +
          where +
          `},"include":["itens","usuario","turmas"]}`
      )
      .then((response) => {
        dispatch(obterTodosConfigurar(response.data));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const obterContratosConfirmado = (donoId) => {
  return (dispatch) => {
    dispatch(requisitar());
    let where = '';
    if (donoId) {
      where = `, "dono": ${donoId}`;
    }
    return axios
      .get(
        `${REQUEST_URL}/contratos?filter={"where":{"status":"confirmado"` +
          where +
          `},"include":["itens","formandos","usuario","dono","turmas"]}`
      )
      .then((response) => {
        dispatch(obterTodos(response.data));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const obterContratosFinalizados = (donoId) => {
  return (dispatch) => {
    dispatch(requisitar());
    let where = '';
    if (donoId) {
      where = `, "dono": ${donoId}`;
    }
    return axios
      .get(
        `${REQUEST_URL}/contratos?filter={"where":{"status":"finalizado"` +
          where +
          `},"include":["itens","formandos","usuario","dono","endereco","turmas"]}`
      )
      .then((response) => {
        dispatch(obterTodosFinalizados(response.data));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const obterContratosQuePagamPorBoleto = () => {
  return (dispatch) => {
    dispatch(requisitar());
    return axios
      .get(
        `${REQUEST_URL}/contratos?filter={"where":{"pagamentoIndividual":"true"},"include":["itens","formandos","usuario","dono","endereco","turmas"]}`
      )
      .then((response) => {
        dispatch(obterTodosPagamentoIndividual(response.data));
      })
      .catch((error) => {
        dispatch(erro(error.response.data.error));
      });
  };
};

export const obterContratoLikePeloNumero = (numero) => {
  return (dispatch) => {
    dispatch(requisitar());
    return axios
      .get(
        `${REQUEST_URL}/contratos?filter={
      "where":{
        "and": [
          {"status": {"neq": "deletado"}}, 
          {"status": {"neq": "arquivado"}},
          {"status": {"neq": "finalizado"}},
          {"numero": ${numero}}
        ]
      },"include":["dono","usuario","itens","turmas", "endereco"]
    }`
      )
      .then((response) => {
        dispatch(obterTodos(response.data));
      })
      .catch((error) => {
        dispatch(erro(error));
      });
  };
};

export const obterPesquisasDeSatisfacao = (donoId) => {
  return (dispatch) => {
    let where = donoId && donoId > 0 ? `"where":{"dono": ${donoId}},` : '';
    return axios
      .get(
        `${REQUEST_URL}/contratos?filter={${where} "include":[{"publicacoes":["pesquisas"]}],"fields":["id","numero"]}`
      )
      .then((response) => {
        let dadosFiltrados = response.data.map((contrato) => {
          contrato.publicacoes = contrato.publicacoes.filter((p) => {
            return (
              (p.tipo === 'Capa Dura' || p.tipo === 'Paginação') && p.pesquisas
            );
          });
          return contrato.publicacoes.length > 0 ? contrato : null;
        });
        dadosFiltrados = dadosFiltrados.filter((contrato) => {
          return contrato !== null;
        });
        dispatch(obterTodos(dadosFiltrados));
      })
      .catch((error) => {
        dispatch(erro(error));
      });
  };
};

export const obterPesquisasDeSatisfacaoPeloContrato = (contrato) => {
  return (dispatch) => {
    return axios
      .get(
        `${REQUEST_URL}/contratos?filter={"where":{"numero":${contrato}},"include":[{"publicacoes":["pesquisas"]}],"fields":["id","numero"]}`
      )
      .then((response) => {
        let dadosFiltrados = response.data.map((contrato) => {
          contrato.publicacoes = contrato.publicacoes.filter((p) => {
            return p.pesquisas;
          });
          return contrato.publicacoes.length > 0 ? contrato : null;
        });
        dadosFiltrados = dadosFiltrados.filter((contrato) => {
          return contrato !== null;
        });
        dispatch(obterTodos(dadosFiltrados));
      })
      .catch((error) => {
        dispatch(erro(error));
      });
  };
};

export const obterPesquisasDeSatisfacaoPeloPeriodo = (
  data,
  designer,
  ignorarAlphaE
) => {
  return (dispatch) => {
    return axios
      .post(`${REQUEST_URL}/pesquisas-por-periodo`, {
        dataInicial: data[0],
        dataFinal: data[1],
      })
      .then((response) => {
        let dadosFiltrados = [];
        response.data.map((contrato) => {
          if (
            (!ignorarAlphaE &&
              (!contrato.contratante ||
                (contrato.contratante &&
                  !contrato.contratante.includes('Alpha-e')))) ||
            (ignorarAlphaE &&
              contrato.contratante &&
              contrato.contratante.includes('Alpha-e'))
          ) {
            if (contrato.dono === designer) {
              dadosFiltrados.push(contrato);
            } else if (designer === 'Todos') {
              dadosFiltrados.push(contrato);
            }
          }
        });
        dispatch(obterTodos(dadosFiltrados));
      })
      .catch((error) => {
        dispatch(erro(error));
      });
  };
};

export const liberarPlanilhaQuantidades = (contrato, liberar) => {
  return (dispatch) => {
    dispatch(requisitar());
    return axios
      .post(`${REQUEST_URL}/liberar-planilha`, {
        contratoId: contrato.id,
        liberar: liberar,
      })
      .then((response) => {
        if (liberar) {
          // Envia email via API PHP ao invés do servidor de email antigo
          axios.post(`${URL_PAGAMENTO}/email/liberacao-planilha`, {
            email: contrato.usuario.email,
            nome: contrato.usuario.nome || contrato.nomeComissao || 'Comissão',
            numeroContrato: contrato.numero
          }, {
            headers: {
              "Authorization": "Bearer " + localStorage.getItem("tokenPagamento")
            }
          }).catch((emailError) => {
            console.error('Erro ao enviar email:', emailError);
            toast.warn('Planilha liberada, mas não foi possível enviar o email de notificação.');
          });
        }
        dispatch(planilhaLiberada(liberar, contrato));
      })
      .catch((error) => {
        dispatch(planilhaLiberada(!liberar, contrato));
        dispatch(
          erro(
            'Erro ao liberar a confirmação da planilha de quantidades. Por favor, tente novamente!'
          )
        );
      });
  };
};

export const estornarPlanilhaQuantidades = (contratoId) => {
  return (dispatch) => {
    return axios
      .post(`${REQUEST_URL}/estornar-planilha`, {
        contratoId: contratoId,
      })
      .then((response) => {
        dispatch(planilhaEstornada(true, contratoId));
      })
      .catch((error) => {
        dispatch(planilhaEstornada(false, contratoId));
        dispatch(
          erro(
            'Erro ao estornar a planilha de quantidades. Por favor, tente novamente!'
          )
        );
      });
  };
};

export const setStatusDistBrindes = (contratoId, status) => {
  return (dispatch) => {
    return axios
      .put(`${REQUEST_URL}/status-distribuicao-brindes`, {
        contratoId: contratoId,
        status: status,
      })
      .then((response) => {
        dispatch(statusDistBrindes(status, contratoId));
      })
      .catch((error) => {
        dispatch(statusDistBrindes(!status, contratoId));
        dispatch(
          erro(
            'Erro ao mudar o status da distribuição dos brindes. Por favor, tente novamente!'
          )
        );
      });
  };
};

export const setStatusEnderecoPreenchido = (contratoId, status) => {
  return (dispatch) => {
    return axios
      .put(`${REQUEST_URL}/status-endereco-entrega`, {
        contratoId: contratoId,
        status: status,
      })
      .then((response) => {
        dispatch(statusEndEntrega(status, contratoId));
      })
      .catch((error) => {
        dispatch(statusEndEntrega(!status, contratoId));
        dispatch(
          erro(
            'Erro ao mudar o status do endereo de entrega. Por favor, tente novamente!'
          )
        );
      });
  };
};

export const setStatusPersonalizacaoLiberada = (contratoId, status) => {
  return (dispatch) => {
    return axios
      .put(`${REQUEST_URL}/status-personalizacao-liberada`, {
        contratoId: contratoId,
        status: status,
      })
      .then((response) => {
        dispatch(statusPersonalizacaoLiberada(status, contratoId));
      })
      .catch((error) => {
        dispatch(statusPersonalizacaoLiberada(!status, contratoId));
        dispatch(
          erro(
            'Erro ao mudar o status da personalização liberada. Por favor, tente novamente!'
          )
        );
      });
  };
};

export const cancelarContrato = (contratoId) => {
  return (dispatch) => {
    return axios
      .delete(`${REQUEST_URL}/contratos/cancelar/${contratoId}`)
      .then((response) => {
        return true;
      })
      .catch((error) => {
        return false;
      });
  };
};

export const estornarConfirmacaoPlanilhaQuantidade = (contrato) => {
  /*return dispatch => {
    dispatch(requisitar());
    return axios.post(`${REQUEST_URL}/liberar-planilha`, {
      contratoId: contrato.id,
      liberar: liberar
    }).then((response) => {
      dispatch(planilhaLiberada(liberar, contrato));
    }).catch(error => {
      dispatch(planilhaLiberada(!liberar, contrato));
      dispatch(erro("Erro ao liberar a confirmação da planilha de quantidades. Por favor, tente novamente!" ));
    });
  }*/
};

export const atualizarStatusLiberacaoPlanilha = (status) => {
  return (dispatch) => {
    dispatch(planilhaLiberada(status, 0));
  };
};



// WEBPACK FOOTER //
// ./src/actions/ContratoActions.js